import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import routes from '../routes.constants'

const PerformanceInsightsRoute = ({ children }) => {
  const { info } = useContext(AppContext)
  const { hasPermission } = useUserPermissions()

  if (!info.userInfo) return null

  const allowsPerformanceInsights = info.selectedStore?.preferences?.allows_performance_insights

  if (!allowsPerformanceInsights || !hasPermission(userPermissions.viewMetrics)) {
    return <Navigate to={routes.dashboardPage} replace />
  }

  return children
}

export default PerformanceInsightsRoute
